/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Chip_SearchInputs */

const vi_shop_chip_search = /** @type {(inputs: Shop_Chip_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm…`)
};

/**

* @param {Shop_Chip_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_chip_search = /** @type {((inputs?: Shop_Chip_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Chip_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_chip_search(inputs)
});